import { useMemo } from 'react';

import { ContentNugget, PriorityPlaylist } from '@backrs_ui/common-ui';

import { mapResourceToContentNugget } from '@backrs_ui/grow-ui/src/components/Lubav/nuggets/resourceNuggetMapper';
import { LubavSuggestedPlaybook, RESOURCE_KEY } from '@backrs_ui/grow-ui/src/models/models';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { openSuggestedPlaylistViewStep } from '@backrs_ui/grow-ui/src/redux/priorities/priorities.slice';

export const usePlaylistNuggets = (playlists: PriorityPlaylist[]) => {
  const dispatch = useAppDispatch();

  const playlistsById = useMemo(() => {
    const map = new Map<number, PriorityPlaylist>();

    playlists.forEach((p) => map.set(p.id, p));

    return map;
  }, [playlists]);

  const playlistNuggets = useMemo(
    () =>
      playlists
        .map((playlist) =>
          mapResourceToContentNugget({
            type: RESOURCE_KEY.SUGGESTED_PLAYBOOKS,
            resource: { id: String(playlist.id), metadata: playlist } as LubavSuggestedPlaybook,
          }),
        )
        .filter((n): n is ContentNugget => n !== null),
    [playlists],
  );

  const handlePlaylistNuggetClick = (nugget: ContentNugget) => {
    const playlist = playlistsById.get(nugget.id);

    if (playlist) {
      dispatch(openSuggestedPlaylistViewStep(playlist));
    } else {
      console.warn('[usePlaylistNuggets] Playlist not found for nugget', nugget.id);
    }
  };

  return { playlistNuggets, handlePlaylistNuggetClick };
};
